import classNames from 'classnames';
import type { ReactElement, RefObject, Ref } from 'react';
import { useRef } from 'react';
import type { LocationProps, LocationRef } from './Location.data';
import styles from './Location.module.scss';
import Heading from '../../atoms/heading/Heading';
import { renderCta } from '../../../util/cta/cta.template';
import Icon from '../../atoms/icon/Icon';

export default function Location({
  className,
  blok,
  ref,
}: LocationProps & { ref?: Ref<LocationRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLButtonElement | null>;
  const containerRef = useRef<HTMLDivElement>(null);

  return renderCta({
    innerTemplate: (
      <>
        <div className={classNames(styles.background, 'abs-fill')} />
        <div className={styles.container} ref={containerRef}>
          <div className={styles.alwaysVisiblePart}>
            <div className={styles.countryAndCity}>
              <Heading
                as="h3"
                size="heading-03"
                transitionInType="splitRotateX3dIn"
                transitionOutType="fadeOut"
                disableTriggerInOnScroll={false}
                className={styles.city}
              >
                {blok.city}
              </Heading>
              {blok.country && (
                <Heading
                  as="span"
                  size="label-small"
                  transitionInType="splitRotateX3dIn"
                  transitionOutType="fadeOut"
                  disableTriggerInOnScroll={false}
                  className={styles.country}
                >
                  {blok.country}
                </Heading>
              )}
            </div>

            <Icon className={styles.arrowRight} name="arrow-right" />
          </div>
        </div>
      </>
    ),
    props: {
      className: classNames(styles.office, styles.resetButtonStyle, className),
      link: {
        href: blok?.office_link?.cached_url || blok?.office_link?.url || '',
        uuid: blok._uid,
      },
      'aria-label': 'Go to location details',
    },
    elementRef,
  });
}
